import { BusinessUnitGroup } from './businessUnitGroup';

/**
 * Locales supported by our downstream apps that are consuming the urls we're building
 */
enum SupportedLocale {
  AmericanEnglish = 'en-US',
  CanadianEnglish = 'en-CA',
  CanadianFrench = 'fr-CA',
}

/*
 * Returns a default locale that can be expected to have content for a given BUG
 */
const getDefaultLocaleForBug = (bug: BusinessUnitGroup): SupportedLocale => {
  switch (bug) {
    case BusinessUnitGroup.EFToursCanada:
      return SupportedLocale.CanadianEnglish;
    case BusinessUnitGroup.StudyAbroad:
    case BusinessUnitGroup.EFTours:
    case BusinessUnitGroup.ExploreAmerica:
    default:
      return SupportedLocale.AmericanEnglish;
  }
};

/*
 * Checks if a given locale can be expected to have content for a given BUG
 */
const isSupportedLocaleForBug = (bug: BusinessUnitGroup, locale: SupportedLocale): boolean => {
  switch (bug) {
    case BusinessUnitGroup.EFToursCanada:
      return locale === SupportedLocale.CanadianEnglish || locale === SupportedLocale.CanadianFrench;
    case BusinessUnitGroup.StudyAbroad:
    case BusinessUnitGroup.EFTours:
    case BusinessUnitGroup.ExploreAmerica:
    default:
      return locale === SupportedLocale.AmericanEnglish;
  }
};

/*
 * Returns the given locale if it is supported by BUG, otherwise returns default locale for BUG
 */
const getSupportedLocaleForBug = (bug: BusinessUnitGroup, locale: SupportedLocale): SupportedLocale => {
  return isSupportedLocaleForBug(bug, locale) ? locale : getDefaultLocaleForBug(bug);
};

export { SupportedLocale, getDefaultLocaleForBug, isSupportedLocaleForBug, getSupportedLocaleForBug };
